import type React from 'react';
import { useEffect } from 'react';
import type { StepProps } from '../types';

declare global {
  interface Window {
    Calendly: any;
  }
}

const ScheduleDemo: React.FC<StepProps> = ({ onNext }) => {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  // Get user info from localStorage
  const name = localStorage.getItem('name') || '';
  const email = localStorage.getItem('email') || '';

  // Create Calendly URL with prefilled information
  const calendlyUrl = `https://calendly.com/demo-sein/30min?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`;

  return (
    <div className='bg-white shadow-sm rounded-lg'>
      <div className='p-4 sm:p-6'>
        <h2 className='text-xl font-medium text-green-600 mb-6'>Schedule Demo</h2>

        <div className='calendly-inline-widget' data-url={calendlyUrl} style={{ minWidth: '320px', height: '700px' }} />
      </div>
    </div>
  );
};

export default ScheduleDemo;
